// Registration Fields
export const FIELDS = {
  COUNTRY: 'country',
  HONOR_CODE: 'honor_code',
  TERMS_OF_SERVICE: 'terms_of_service',
};

export const PROFESSION_TYPES = Object.freeze({
  TEACHER: '00',
  MHP_CREATIVE_ARTS_THERAPIST: '05',
  MHP_MARRIAGE_FAMILY_THERAPIST: '06',
  MHP_MENTAL_HEALTH_COUNSELOR: '18',
  PSYCHOANALYST: '19',
  RN_NURSE_PRACTITIONER: '22',
  DENTIST: '50',
  DENTAL_HYGIENIST: '51',
  OPTOMETRY: '56',
  MEDICINE: '60',
  PODIATRY: '65',
  ATHLETIC_TRAINING: '68',
  PSYCHOLOGY: '68',
  CHIROPRACTIC: '70',
  LICENSED_BEHAVIOR_ANALYST: '71',
  LMSW: '72',
  LCSW: '73',
  CBAA: '78',
  RESTRICTED_DENTAL_FACULTY: '79',
  OTHER: '99',
});

// Registration Error Codes
export const FORBIDDEN_REQUEST = 'forbidden-request';
export const FORM_SUBMISSION_ERROR = 'form-submission-error';
export const INTERNAL_SERVER_ERROR = 'internal-server-error';
export const TPA_AUTHENTICATION_FAILURE = 'tpa-authentication-failure';
export const TPA_SESSION_EXPIRED = 'tpa-session-expired';
export const STUDENT_RECORD_NOT_FOUND = 'student-record-not-found';